import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var Dictionary = /*#__PURE__*/function () {
  function Dictionary() {
    _classCallCheck(this, Dictionary);
    this.translations = window.__translations || {};
  }
  return _createClass(Dictionary, [{
    key: "setTranslations",
    value: function setTranslations(t) {
      this.translations = t;
    }
  }, {
    key: "getTranslations",
    value: function getTranslations() {
      return this.translations;
    }
  }]);
}();
export default new Dictionary();
//# sourceMappingURL=dictionary.js.map
